var exports = {
  "Qs": "x127c5a35--1f29d3--content",
  "nV": "x127c5a35--1f29d3--gallery",
  "vw": "x127c5a35--1f29d3--rounted_gallery",
  "xe": "x127c5a35--1f29d3--space",
  "VS": "x127c5a35--1f29d3--empty_photo",
  "wx": "x127c5a35--1f29d3--header",
  "rd": "x127c5a35--1f29d3--header--redesign",
  "BI": "x127c5a35--1f29d3--favorite",
  "_Y": "x127c5a35--1f29d3--favorite--redesign",
  "$_": "x127c5a35--1f29d3--media",
  "Nr": "x127c5a35--1f29d3--card",
  "YI": "x127c5a35--1f29d3--card--redesign",
  "ne": "x127c5a35--1f29d3--controls",
  "bu": "x127c5a35--1f29d3--commercial-info-ready-business-wrapper",
  "D7": "x127c5a35--1f29d3--shields_wrapper",
};

module.exports = exports;
